import { Dropdown } from 'react-bootstrap';
import { forwardRef } from 'react';

import { LangInfo } from '../lang-info/LangInfo';
import { LangChooserButton } from '../lang-chooser-button/LangChooserButton';

const CustomToggle = forwardRef(({ toggleButtonComponent, ...props }, ref) => {
    const ToggleComponent = toggleButtonComponent || LangChooserButton;
    return (
            <div ref={ref}>
                <ToggleComponent {...props}/>
            </div>
    );
});

export const LangChooserDropdown = ({ onSelectLang, locales, locale, toggleButtonComponent }) => (
    <Dropdown align="end" onSelect={onSelectLang}>
        <Dropdown.Toggle as={CustomToggle} toggleButtonComponent={toggleButtonComponent} />
        <Dropdown.Menu>
            {locales.map(({ value, fullName }) => (
                <Dropdown.Item active={value === locale} key={value} eventKey={value}>
                    <LangInfo iconName={value} langName={fullName} />
                </Dropdown.Item>
            ))}
        </Dropdown.Menu>
    </Dropdown>
);
